

export interface MultiTemplateTransactionalEmailTemplateModel {
  emailTemplateName: string;
  emailSubject: string;
  emailContent: string;
  emailMjmlContent: string;
}
